/* SPECIFIC JS FOR THE VIEW IF NEEDED */
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = galerie_d62fa;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _scrollmagic = require('scrollmagic');

var _scrollmagic2 = _interopRequireDefault(_scrollmagic);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

require("scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap");

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

var _gsapScrollToPlugin = require('gsap/ScrollToPlugin');

var _gsapScrollToPlugin2 = _interopRequireDefault(_gsapScrollToPlugin);

var _gsapTweenMax = require('gsap/TweenMax');

var _gsapTweenMax2 = _interopRequireDefault(_gsapTweenMax);

function galerie_d62fa() {
	var self = this;

	var _rub = document.querySelector('.galerie_d62fa');
	var images = [];
	var imagesHover = [];
	var sequence = {
		interval: '',
		imageNumber: 0,
		ctx: '',
		tempInterval: '',
		canvas: document.getElementById('sequence-canvas')
	};

	if (sequence.canvas) {
		sequence.canvas.width = window.innerWidth;
		sequence.canvas.height = window.innerHeight;
		if (window.innerWidth <= 768) {
			sequence.canvas.height = window.innerHeight - 50;
		}
		sequence.ctx = sequence.canvas.getContext('2d');
	}

	function addListeners() {
		_pubsub2['default'].on('resize', resize);
	}

	function resize(winW, winH) {}

	function gallerySwiper() {
		if (document.querySelectorAll('.swiper-gallery').length) {
			window.gallerySwiper = new _swiper2['default'](document.querySelector('.swiper-gallery'), {
				direction: 'horizontal',
				speed: 1000,
				slidesPerView: 3,
				spaceBetween: '25%',
				centeredSlides: true,
				threshold: 100,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			});
		}
	}

	function lightboxSwiper() {
		if (document.querySelectorAll('.swiper-lightbox').length) {
			window.lightboxSwiper = new _swiper2['default'](document.querySelector('.swiper-lightbox'), {
				direction: 'horizontal',
				speed: 1000,
				threshold: 100,
				slidesPerView: 1,
				centeredSlides: true,
				initialSlide: 1,
				spaceBetween: 50,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			});

			document.querySelector('.lightbox-container .close-menu').addEventListener('click', function () {
				document.querySelector('.lightbox-container').classList.remove('active');
				var iframes = document.querySelectorAll('.lightbox-container iframe');
				for (var index = 0; index < iframes.length; index++) {
					var iframe = iframes[index];

					iframe.src = iframe.src;
				}
			});
		}
	}
	_pubsub2['default'].on('initLightboxSwiper', lightboxSwiper);

	function initLightBox() {

		var imageLinks = document.querySelectorAll('.gallery .swiper-gallery .swiper-slide');
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = imageLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var item = _step.value;

				item.addEventListener('click', function (e) {
					e.preventDefault();
					if (this.getAttribute('data-video')) {
						document.querySelector('.videos-container').classList.add('active');
						document.querySelector('.videos-container .video[data-alt="' + this.getAttribute('data-alt') + '"]').classList.add('active');
					}
				});
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator['return']) {
					_iterator['return']();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		var imageLinks = document.querySelectorAll('.gallery-container-mobile .item');
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = imageLinks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var item = _step2.value;

				item.addEventListener('click', function (e) {
					e.preventDefault();
					document.querySelector('.videos-container').classList.add('active');
					document.querySelector('.videos-container .video[data-alt="' + this.getAttribute('data-alt') + '"]').classList.add('active');
				});
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2['return']) {
					_iterator2['return']();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		var closes = document.querySelectorAll('.videos-container .close-menu');
		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = closes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var close = _step3.value;

				close.addEventListener('click', function () {
					this.parentElement.classList.remove('active');
					document.querySelector('.videos-container').classList.remove('active');

					var iframes = document.querySelectorAll('.videos-container iframe');
					for (var index = 0; index < iframes.length; index++) {
						var iframe = iframes[index];

						iframe.src = iframe.src;
					}
				});
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3['return']) {
					_iterator3['return']();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}
	}

	_pubsub2['default'].on('initGalerieTriggers', initLightBox);

	function initSequence() {
		// Sequence
		if (document.querySelectorAll('.sequence-container').length) {
			for (var i = 1; i <= 36; i++) {
				var image = new Image();
				image.src = WEB_ROOT_IMAGES + '360/tour-plans-surface-' + i + '.jpg';
				images.push(image);
			}

			setTimeout(function () {
				playSequence();
			}, 3000);
		}

		// Hover canvas
		var loadImg = function loadImg(c) {
			var image = new Image();

			image.onload = function () {

				imagesHover.push(image);

				c.width = window.innerWidth;
				c.height = window.innerHeight;
				if (window.innerWidth <= 768) {
					c.height = window.innerHeight - 50;
				}

				var ctx = c.getContext('2d');
				drawImageProp(ctx, image, 0, 0, window.innerWidth, window.innerHeight);
			};
			image.src = c.getAttribute('data-image');
		};

		window.onload = function () {
			var canvas = document.querySelectorAll('.clicked-item');

			for (var i = 0; i < canvas.length; i++) {
				var c = canvas[i];

				loadImg(c);
			}
		};
	}

	function playSequence() {
		var i = sequence.imageNumber ? sequence.imageNumber : 1;

		sequence.interval = setInterval(function () {
			sequence.imageNumber = i % 36;
			drawImageProp(sequence.ctx, images[sequence.imageNumber], 0, 0, window.innerWidth, window.innerHeight);
			i++;
		}, 200);
	}

	function drawImageProp(ctx, img, x, y, w, h, offsetX, offsetY) {

		if (arguments.length === 2) {
			x = y = 0;
			w = ctx.canvas.width;
			h = ctx.canvas.height;
			if (window.innerWidth <= 768) {
				h = window.innerHeight - 50;
			}
		} else {
			if (window.innerWidth <= 768) {
				h = h - 50;
			}
		}

		// default offset is center
		offsetX = typeof offsetX === "number" ? offsetX : 0.5;
		offsetY = typeof offsetY === "number" ? offsetY : 1;

		// keep bounds [0.0, 1.0]
		if (offsetX < 0) offsetX = 0;
		if (offsetY < 0) offsetY = 0;
		if (offsetX > 1) offsetX = 1;
		if (offsetY > 1) offsetY = 1;

		var iw = img.width,
		    ih = img.height,
		    r = Math.min(w / iw, h / ih),
		    nw = iw * r,
		    // new prop. width
		nh = ih * r,
		    // new prop. height
		cx,
		    cy,
		    cw,
		    ch,
		    ar = 1;

		// decide which gap to fill
		if (nw < w) ar = w / nw;
		if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh; // updated
		nw *= ar;
		nh *= ar;

		// calc source rectangle
		cw = iw / (nw / w);
		ch = ih / (nh / h);

		cx = (iw - cw) * offsetX;
		cy = (ih - ch) * offsetY;

		// make sure source rectangle is valid
		if (cx < 0) cx = 0;
		if (cy < 0) cy = 0;
		if (cw > iw) cw = iw;
		if (ch > ih) ch = ih;

		// fill image in dest. rectangle
		ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
	}

	function listHover() {
		var listItems = document.querySelectorAll('.plans-list li');

		var _iteratorNormalCompletion4 = true;
		var _didIteratorError4 = false;
		var _iteratorError4 = undefined;

		try {
			for (var _iterator4 = listItems[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
				var item = _step4.value;

				item.addEventListener('mouseover', function () {
					clearInterval(sequence.interval);
					clearInterval(sequence.tempInterval);
					var self = this;
					if (sequence.imageNumber > parseInt(self.getAttribute('data-image-number'))) {
						var sens = false;
					} else {
						var sens = true;
					}
					sequence.tempInterval = setInterval(function () {
						drawImageProp(sequence.ctx, images[sequence.imageNumber], 0, 0, window.innerWidth, window.innerHeight);

						if (sequence.imageNumber === parseInt(self.getAttribute('data-image-number'))) {
							clearInterval(sequence.tempInterval);

							var clickedItems = document.querySelectorAll('.clicked-item');

							var _iteratorNormalCompletion6 = true;
							var _didIteratorError6 = false;
							var _iteratorError6 = undefined;

							try {
								for (var _iterator6 = clickedItems[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
									var item = _step6.value;

									item.classList.remove('active');
								}
							} catch (err) {
								_didIteratorError6 = true;
								_iteratorError6 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion6 && _iterator6['return']) {
										_iterator6['return']();
									}
								} finally {
									if (_didIteratorError6) {
										throw _iteratorError6;
									}
								}
							}

							document.querySelector('.clicked-container').classList.add('active');
							document.querySelector('.clicked-item[data-floor="' + self.getAttribute('data-floor') + '"]').classList.add('active');
						} else {
							if (sens) {
								sequence.imageNumber++;
							} else {
								sequence.imageNumber--;
							}
						}
					}, 50);
				});

				item.addEventListener('mouseleave', function () {
					var clickedItems = document.querySelectorAll('.clicked-item');

					document.querySelector('.clicked-container').classList.remove('active');

					var _iteratorNormalCompletion7 = true;
					var _didIteratorError7 = false;
					var _iteratorError7 = undefined;

					try {
						for (var _iterator7 = clickedItems[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
							var item = _step7.value;

							item.classList.remove('active');
						}
					} catch (err) {
						_didIteratorError7 = true;
						_iteratorError7 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion7 && _iterator7['return']) {
								_iterator7['return']();
							}
						} finally {
							if (_didIteratorError7) {
								throw _iteratorError7;
							}
						}
					}

					clearInterval(sequence.interval);
					clearInterval(sequence.tempInterval);
					playSequence();
				});
			}
		} catch (err) {
			_didIteratorError4 = true;
			_iteratorError4 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion4 && _iterator4['return']) {
					_iterator4['return']();
				}
			} finally {
				if (_didIteratorError4) {
					throw _iteratorError4;
				}
			}
		}

		var mobileSelect = document.querySelector('.services-list-mobile select');

		mobileSelect.addEventListener('change', function () {

			clearInterval(sequence.interval);
			clearInterval(sequence.tempInterval);

			window.scroll({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});

			var self = this.options[this.selectedIndex];
			if (sequence.imageNumber > parseInt(self.getAttribute('data-image-number'))) {
				var sens = false;
			} else {
				var sens = true;
			}
			sequence.tempInterval = setInterval(function () {
				drawImageProp(sequence.ctx, images[sequence.imageNumber], 0, 0, window.innerWidth, window.innerHeight);

				if (sequence.imageNumber === parseInt(self.getAttribute('data-image-number'))) {
					clearInterval(sequence.tempInterval);

					/*var titles = document.querySelectorAll('.floor-title')
     for (var title of titles) {
     if (title.getAttribute('data-floor') === self.getAttribute('data-floor')) {
      title.classList.add('active')
     } else {
      title.classList.remove('active')
     }
     }*/

					document.querySelector('.services-list-mobile').classList.remove('active');

					var clickedItems = document.querySelectorAll('.clicked-item');

					var _iteratorNormalCompletion5 = true;
					var _didIteratorError5 = false;
					var _iteratorError5 = undefined;

					try {
						for (var _iterator5 = clickedItems[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
							var item = _step5.value;

							item.classList.remove('active');
						}
					} catch (err) {
						_didIteratorError5 = true;
						_iteratorError5 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion5 && _iterator5['return']) {
								_iterator5['return']();
							}
						} finally {
							if (_didIteratorError5) {
								throw _iteratorError5;
							}
						}
					}

					document.querySelector('.clicked-container').classList.add('active');
					document.querySelector('.clicked-item[data-floor="' + self.getAttribute('data-floor') + '"]').classList.add('active');
				} else {
					if (sens) {
						sequence.imageNumber++;
					} else {
						sequence.imageNumber--;
					}
				}
			}, 50);
		});
	}

	function listHoverAccess() {
		var listItems = document.querySelectorAll('.plans-list li');

		var _iteratorNormalCompletion8 = true;
		var _didIteratorError8 = false;
		var _iteratorError8 = undefined;

		try {
			for (var _iterator8 = listItems[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
				var item = _step8.value;

				item.addEventListener('mouseover', function () {
					document.querySelector('.clicked-container').classList.add('active');
					document.querySelector('.clicked-item[data-index="' + this.getAttribute('data-index') + '"]').classList.add('active');
				});

				item.addEventListener('mouseleave', function () {
					var clickedItems = document.querySelectorAll('.clicked-item');

					document.querySelector('.clicked-container').classList.remove('active');

					var _iteratorNormalCompletion9 = true;
					var _didIteratorError9 = false;
					var _iteratorError9 = undefined;

					try {
						for (var _iterator9 = clickedItems[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
							var item = _step9.value;

							item.classList.remove('active');
						}
					} catch (err) {
						_didIteratorError9 = true;
						_iteratorError9 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion9 && _iterator9['return']) {
								_iterator9['return']();
							}
						} finally {
							if (_didIteratorError9) {
								throw _iteratorError9;
							}
						}
					}
				});
			}
		} catch (err) {
			_didIteratorError8 = true;
			_iteratorError8 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion8 && _iterator8['return']) {
					_iterator8['return']();
				}
			} finally {
				if (_didIteratorError8) {
					throw _iteratorError8;
				}
			}
		}
	}

	function listClick() {
		var listItems = document.querySelectorAll('.plans-list li');

		var lightboxs = document.querySelectorAll('.lightbox-container');

		var _iteratorNormalCompletion10 = true;
		var _didIteratorError10 = false;
		var _iteratorError10 = undefined;

		try {
			for (var _iterator10 = lightboxs[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
				var item = _step10.value;

				item.classList.remove('active');
			}
		} catch (err) {
			_didIteratorError10 = true;
			_iteratorError10 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion10 && _iterator10['return']) {
					_iterator10['return']();
				}
			} finally {
				if (_didIteratorError10) {
					throw _iteratorError10;
				}
			}
		}

		var closes = document.querySelectorAll('.lightbox-container .close-menu');

		var _iteratorNormalCompletion11 = true;
		var _didIteratorError11 = false;
		var _iteratorError11 = undefined;

		try {
			for (var _iterator11 = closes[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
				var close = _step11.value;

				close.addEventListener('click', function () {
					this.parentElement.parentElement.classList.remove('active');
					document.querySelector('.clicked-container').classList.remove('indexed');
				});
			}
		} catch (err) {
			_didIteratorError11 = true;
			_iteratorError11 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion11 && _iterator11['return']) {
					_iterator11['return']();
				}
			} finally {
				if (_didIteratorError11) {
					throw _iteratorError11;
				}
			}
		}
	}

	function lightboxClick() {
		var ctas = document.querySelectorAll('.photos-cta');

		var _iteratorNormalCompletion12 = true;
		var _didIteratorError12 = false;
		var _iteratorError12 = undefined;

		try {
			for (var _iterator12 = ctas[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
				var cta = _step12.value;

				cta.addEventListener('click', function () {
					this.parentElement.querySelector('.lightbox-container').classList.add('active');
					document.querySelector('.clicked-container').classList.add('indexed');
				});
			}
		} catch (err) {
			_didIteratorError12 = true;
			_iteratorError12 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion12 && _iterator12['return']) {
					_iterator12['return']();
				}
			} finally {
				if (_didIteratorError12) {
					throw _iteratorError12;
				}
			}
		}

		var closes = document.querySelectorAll('.lightbox-container .close-menu');

		var _iteratorNormalCompletion13 = true;
		var _didIteratorError13 = false;
		var _iteratorError13 = undefined;

		try {
			for (var _iterator13 = closes[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
				var close = _step13.value;

				close.addEventListener('click', function () {
					this.parentElement.parentElement.classList.remove('active');
					document.querySelector('.clicked-container').classList.remove('indexed');
				});
			}
		} catch (err) {
			_didIteratorError13 = true;
			_iteratorError13 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion13 && _iterator13['return']) {
					_iterator13['return']();
				}
			} finally {
				if (_didIteratorError13) {
					throw _iteratorError13;
				}
			}
		}
	}

	function initSliders() {
		new _swiper2['default']('.swiper-lightbox', {
			direction: 'horizontal',
			speed: 1000,
			slidesPerView: 1,
			centeredSlides: true,
			initialSlide: 1,
			spaceBetween: 50,
			threshold: 100,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			pagination: {
				el: '.swiper-pagination',
				dynamicBullets: true
			}
		});
	}

	(function init() {
		gallerySwiper();
		initLightBox();
		lightboxSwiper();
		lightboxClick();

		if (document.querySelectorAll('.sequence-container').length) {
			initSequence();
			listHover();
			listClick();
			initSliders();
		}

		if (document.querySelectorAll('.access').length) {
			listHoverAccess();
		}
	})();
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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